// extracted by mini-css-extract-plugin
export default {"main":"_59c60306c5 fcce83aa23","xmark":"_40f065d58b","fl_img":"b82d4e4b48 fdbe8cf303"};